import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

/**
 * WhatsApp Callback Component
 * Handles the OAuth callback from Meta's Embedded Signup
 * This page receives the authorization code and sends it to the parent window
 */
const WhatsAppCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    console.log('WhatsApp Callback received:', { code, state, error });

    if (error) {
      // Send error to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'whatsapp_signup_error',
          error: errorDescription || error
        }, window.location.origin);
      }
      
      // Close popup after a short delay
      setTimeout(() => {
        window.close();
      }, 2000);
      
      return;
    }

    if (code && state) {
      // Send success message to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'whatsapp_signup_success',
          code,
          state
        }, window.location.origin);
      }
      
      // Close popup after sending the message
      setTimeout(() => {
        window.close();
      }, 1000);
    } else {
      // No code or state, redirect to WhatsApp integration page
      setTimeout(() => {
        if (window.opener) {
          window.close();
        } else {
          navigate('/whatsapp');
        }
      }, 2000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full mx-4 text-center">
        <div className="mb-6">
          <Loader2 className="h-16 w-16 text-green-600 animate-spin mx-auto" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Procesando autenticación...
        </h2>
        <p className="text-gray-600">
          Conectando tu cuenta de WhatsApp Business
        </p>
        <p className="text-sm text-gray-500 mt-4">
          Esta ventana se cerrará automáticamente
        </p>
      </div>
    </div>
  );
};

export default WhatsAppCallback;
